import axios from 'axios';
import React, { useCallback, useState } from 'react';
import AuthField from './components/AuthField';
import AuthForm from './components/AuthForm';
import AuthPageWrapper from './components/AuthPageWrapper';

export default function ResetPassword({ promptId, navTo, resetConfig }) {
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState({ open: false, message: '', severity: 'error' });

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      setAlert((prev) => ({ ...prev, open: false }));
      setIsLoading(true);
      resetConfig();
      try {
        const { data } = await axios.post(
          '/resetPassword',
          { promptId, newPassword, newPasswordConfirm },
          { validateStatus: () => true }
        );
        if (data.redirect) {
          setAlert({ open: true, message: 'Password reset successfully.', severity: 'success' });
          navTo('resetPasswordSuccess');
        } else {
          setAlert({ open: true, message: data.error || 'Reset failed.', severity: 'error' });
        }
      } catch {
        setAlert({ open: true, message: 'Server error. Try again later.', severity: 'error' });
      } finally {
        setIsLoading(false);
      }
    },
    [promptId, newPassword, newPasswordConfirm, navTo, resetConfig]
  );

  return (
    <AuthPageWrapper
      alert={alert}
      onCloseAlert={() => setAlert((prev) => ({ ...prev, open: false }))}
    >
      <AuthForm
        disableSubmit={!newPassword || !newPasswordConfirm}
        isLoading={isLoading}
        onCancel={() => navTo('login')}
        onSubmit={handleSubmit}
        sectionTitle="Reset Password"
        submitText={isLoading ? 'Processing...' : 'Reset Password'}
      >
        <AuthField
          disabled={isLoading}
          label="New Password"
          onChange={(e) => setNewPassword(e.target.value)}
          type="password"
          value={newPassword}
        />
        <AuthField
          disabled={isLoading}
          label="Confirm New Password"
          onChange={(e) => setNewPasswordConfirm(e.target.value)}
          type="password"
          value={newPasswordConfirm}
        />
      </AuthForm>
    </AuthPageWrapper>
  );
}
